import * as React from 'react';
import {RouteComponentProps, withRouter} from 'react-router-dom';
import {URL} from '../../Config/appConfig';
import {ErrorDetail} from '../../Config/dataModel';
import {getErrorCodeStr} from '../../Util/errorUtil';
import ErrorHandlerWrapper from './EventHandlerWrapper';
import {disconnect} from "../../Websocket/websocket";
import '../../style/error.css';
import Translator from '../Translator/Translator';
import { getLanguage } from 'src/Util/language';

const failLoading = require('../../resource/img/fail-loading.svg');

interface ErrorHandlerProps {
    onError?: () => void,
    displayAtCenter?: boolean
}

interface ErrorHandlerState {
    errors: ErrorDetail[]
}

class ErrorHandler extends React.Component <RouteComponentProps & ErrorHandlerProps, ErrorHandlerState> {
    // Use internal state variable to avoid async update using this.setState
    public errors = [];
    public activate = false;

    public constructor(props: ErrorHandlerProps) {
        super(props);
        this.state = {
            errors: []
        };
        this.addError = this.addError.bind(this);
        // this.removeError = this.removeError.bind(this);
        this.clearErrors = this.clearErrors.bind(this);
    }

    public componentDidMount() {
        this.activate = true;
    }

    public componentWillUnmount() {
        this.activate = false;
    }

    public setError() {
        if(this.activate){
            if (this.props.onError) { this.props.onError(); }
            this.setState({
                errors: this.errors
            });
        }
    }

    public addError(error: any) {
        if (error.detail.code === 102) {
            this.props.history.push(URL.LOGIN);
            disconnect();
        }
        const detail = error.detail;
        const orig = this.errors;
        let filtered = orig.filter((elem) => elem.code !== detail.code);

        // Synchrounous state update
        this.errors = filtered.concat(error.detail);

        // Remove duplicates and insert again
        if (filtered.length !== orig.length) {
            this.setState({
                errors: filtered
            });
            // Simulate loading
            setTimeout(() => {this.setError()}, 200);
        }
        else { this.setError(); }
    }

    // removeError() {
    //     let newErrors = this.state.errors;
    //     newErrors.shift();
    //     this.setState({
    //         errors: newErrors
    //     });
    // }

    public clearErrors() {
        if(this.activate){
            this.errors = [];
            this.setState({
                errors: this.errors
            });
        }
    }

    public errorMsgBlock(detail: ErrorDetail, idx: number) {
        if (this.props.displayAtCenter) {
            return (
                <div key={idx} className="cmHorCenter connectionErrorMsgContainer">
                    <img className="cmHorCenter" src={failLoading}/>
                    <div className="connectionErrorMsg">{detail.message}</div>
                </div>
            );
        }

        let errorCode = getLanguage() === "zh-hk" ? `(錯誤代碼: ${getErrorCodeStr(detail.code)})` : `(error code: ${getErrorCodeStr(detail.code)})`;
        return (
            <div key={idx} className="cmErrorText">
                <span className="errorMsg">{detail.message}</span>
                <span className="errorMsgCode">{errorCode}</span>
            </div>
        );
    }

    public render() {
        return (
            // removeError={this.removeError}
            <ErrorHandlerWrapper
                addError={this.addError}
                clearErrors={this.clearErrors}>
                <div className={`errorMsgContainer${this.state.errors.length ? " show" : ""}`}>
                    {this.state.errors.map((curr, idx) => {
                        return this.errorMsgBlock(curr, idx)
                    })}
                </div>
            </ErrorHandlerWrapper>
        );
    }
}

export default withRouter(ErrorHandler);



// WEBPACK FOOTER //
// ./src/Components/ErrorHandler/ErrorHandler.tsx